import EmblaCarousel from 'embla-carousel'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'

import debounce from 'lodash/debounce'
export class ThumbSlider {
	constructor(options) {
		this.options = options

		this.element = options.element

		this.elSliderContainer = this.element
		this.elSlider = options.container

		//

		// check if the first or last slide is a video

		this.init()

		this.initControls()
	}
	init() {
		this.plugins = []

		if (this.options.wheelGestures) {
			this.plugins.push(WheelGesturesPlugin())
		}

		this.slider = EmblaCarousel(
			this.elSlider,
			{
				// watchDrag: false,
				loop: true,
				// skipSnaps: true,
				align: 'start',
				...this.options.emblaOptions,
			},
			this.plugins,
		)

		// listen to resize
		this.debouncedOnSliderResize = debounce(this.onSliderResize.bind(this), 100)
		this.slider.on('resize', this.debouncedOnSliderResize)

		this.bndOnSliderInit = this.onSliderInit.bind(this)
		this.slider.on('init', this.bndOnSliderInit)

		if (this.options.wheelGestures && window.matchMedia('(hover:hover)').matches) {
			this.disableOverscroll()
		}
	}
	getInstance() {
		return this.slider
	}
	onSliderInit() {
		this.element.classList.add('is-initialized')
	}
	disableOverscroll() {
		// this piece of codes disabled the bouncy overscroll
		// add a check to check if this is a touch device
		// because on touch devices the overscroll is not a problem
		this.slider.on('scroll', (emblaApi) => {
			const { limit, target, location, offsetLocation, scrollTo, translate, scrollBody } = emblaApi.internalEngine()

			let edge = null

			if (location.get() >= limit.max) edge = limit.max
			if (location.get() <= limit.min) edge = limit.min

			if (edge !== null) {
				location.set(edge)
				target.set(edge)
				translate.to(edge)
				translate.toggleActive(false)
				scrollBody.useDuration(0).useFriction(0)
				scrollTo.distance(0, false)

				//
				// offsetLocation.set(edge)
				// location.set(edge)
				// target.set(edge)
				// translate.to(edge)
				// translate.toggleActive(false)
				// 	scrollBody.useDuration(0).useFriction(0)
				// 	scrollTo.distance(0, false)
			} else {
				translate.toggleActive(true)
			}
		})
	}
	onSlideSelect() {
		const index = this.slider.selectedScrollSnap()
		const slide = this.slides[index]

		if (this.hasPagination) {
			this.updatePagination()
		}
	}
	handleVideoPlay(slide) {
		let elVideoCard = slide.el.querySelector('.video-card')

		// stop all other videos
		this.slides.forEach((s) => {
			this.handleVideoStop(s)
		})

		slide.elVideo.play()
		if (elVideoCard) {
			elVideoCard.classList.add('is-playing')
		}
	}
	handleVideoStop(slide) {
		let elVideoCard = slide.el.querySelector('.video-card')

		slide.elVideo.pause()
		slide.elVideo.currentTime = 0

		if (elVideoCard) {
			elVideoCard.classList.remove('is-playing')
		}
	}
	onSliderResize() {
		if (this.elSliderPagination) {
			this.initPagination()
		}
		this.updateControls()
	}

	destroyPagination() {
		if (!this.elSliderPagination) return

		this.element.classList.remove('has-pagination')
		this.hasPagination = false
		this.elSliderPagination.innerHTML = ''

		this.elSliderPagination.removeEventListener('click', this.bndOnPaginationClick)
		// this.slider.off('select', this.bndUpdatePagination)
	}

	initPagination() {
		//  !! think about something to handle the more cells are in view constantly
		// so cliking the last buttons in the pagination does not have a lot of effect
		if (!this.elSliderPagination) return

		this.destroyPagination()
		const nrOfSlides = this.slider.scrollSnapList().length

		if (nrOfSlides <= 1) {
			return
		}

		this.element.classList.add('has-pagination')

		this.bndOnPaginationClick = this.onPaginationClick.bind(this)

		this.elSliderPagination.addEventListener('click', this.bndOnPaginationClick)
		this.hasPagination = true

		for (let i = 0; i < nrOfSlides; i++) {
			const elDot = document.createElement('button')
			elDot.classList.add('article-slider__pag-button')
			// elDot.setAttribute('data-index', i)
			// elDot.addEventListener('click', this.onPaginationDotClick.bind(this))
			this.elSliderPagination.appendChild(elDot)
		}

		this.paginationButtons = Array.from(this.elSliderPagination.querySelectorAll('button'))
		//
		// this.bndUpdatePagination = this.updatePagination.bind(this)
		// this.slider.on('select', this.bndUpdatePagination)

		//

		this.updatePagination()
	}
	updatePagination(data) {
		// console.log(data)
		this.paginationButtons.forEach((el, index) => {
			if (index === this.slider.selectedScrollSnap()) {
				el.classList.add('is-active')
			} else {
				el.classList.remove('is-active')
			}
		})
	}
	onPaginationClick(ev) {
		if (!ev.target.tagName === 'BUTTON') return
		const index = Array.from(this.elSliderPagination.children).indexOf(ev.target)

		this.slider.scrollTo(index)
	}

	initControls() {
		this.elBtnPrev = this.element.querySelector('.js-slider-prev')
		this.elBtnNext = this.element.querySelector('.js-slider-next')

		if (!this.elBtnPrev && !this.elBtnNext) return

		if (this.elBtnPrev) {
			this.bndOnPrevClick = this.onPrevClick.bind(this)
			this.elBtnPrev.addEventListener('click', this.bndOnPrevClick, false)
		}

		if (this.elBtnNext) {
			this.bndOnNextClick = this.onNextClick.bind(this)
			this.elBtnNext.addEventListener('click', this.bndOnNextClick, false)
		}

		this.bndUpdateControls = this.updateControls.bind(this)
		this.slider.on('select', this.bndUpdateControls)

		this.updateControls()
	}
	updateControls() {
		if (!this.elBtnPrev || !this.elBtnNext) return

		const index = this.slider.selectedScrollSnap()

		if (!this.slider.canScrollPrev()) {
			this.elBtnPrev.classList.add('is-disabled')
		} else {
			this.elBtnPrev.classList.remove('is-disabled')
		}
		if (!this.slider.canScrollNext()) {
			this.elBtnNext.classList.add('is-disabled')
		} else {
			this.elBtnNext.classList.remove('is-disabled')
		}
	}

	onPrevClick(ev) {
		ev.preventDefault()
		ev.stopPropagation()
		this.slider.scrollPrev()
	}

	onNextClick(ev) {
		ev.preventDefault()
		ev.stopPropagation()
		this.slider.scrollNext()
	}

	destroy() {
		this.slider.destroy()
		this.element.classList.remove('is-initialized')

		this.slider.off('select', this.bndOnSlideSelect)
	}
}
